<template>
    <Tag :severity="severity">{{ nome }}</Tag>
</template>

<script>
export default {
    name: 'TagStatusChamado',
    data() {
        return {
            statusChamado: [
                { name: 'Em análise', value: 'EM_ANALISE', tag: 'warning' },
                { name: 'Em consolidação', value: 'EM_CONSOLIDACAO', tag: 'warning' },
                { name: 'Devolvido para ajustes', value: 'DEVOLVIDO_PARA_AJUSTES', tag: 'secondary' },
                { name: 'Produto cadastrado', value: 'PRODUTO_CADASTRADO', tag: 'success' },
                { name: 'Produto não cadastrado', value: 'PRODUTO_NAO_CADASTRADO', tag: 'danger' },
                { name: 'Enviado', value: 'ENVIADO', tag: 'success' },
            ],
        };
    },
    props: {
        status: {
            type: String,
        },
    },
    computed: {
        nome() {
            return this.statusChamado.filter((status) => status.value == this.status)[0]?.name;
        },
        severity() {
            return this.statusChamado.filter((status) => status.value == this.status)[0]?.tag;
        },
    },
};
</script>
